import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {DepartmentModel} from '@/libs/Api';
import {DepartmentsDataService} from '@/libs/departments/departments-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const departmentsStore = registerCrudStore<DepartmentModel, DepartmentModel>(BusinessModule.Department, new DepartmentsDataService());
